var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-actions"},[_c('AppLangSwitcher',{attrs:{"placement":_vm.placement}}),(_vm.$isLoggedIn)?_c('div',{staticClass:"s-card s-card--no-padding",on:{"click":_vm.logout}},[_c('div',{staticClass:"header-actions__item"},[_c('feather',{attrs:{"type":"log-out","size":"24","stroke":"var(--s-black-color-80)"}})],1)]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }